




































































































import { Component, Vue, Prop, Emit, Ref, Watch } from 'vue-property-decorator';

import {
  GQL_ameldingNewData,
  GQL_ameldingNewData_currentUnit,
  GQL_ameldingNewDataVariables,
  GQL_ameldingNewData_currentUnit_subUnits_workRelations,
  GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding,
} from '@/queries/__generated__/ameldingNewData';
import { SmartQuery } from 'vue-apollo-decorator';

import AmeldingFormSubUnit from './AmeldingFormSubUnit.vue';
import { filterWorkRelationsForNewAmelding } from '@/app/Altinn';
import { PickedWorkRelation } from './AmeldingFormWorkRelation.vue';
import { ALL_PENSION_UNIT_SELECTIONS } from '@/queries/PensionUnitSelection';
import { GQL_pensionUnitSelections, GQL_pensionUnitSelections_currentUnit_pensionUnitSelections, GQL_pensionUnitSelections_currentUnit_pensionUnitSelections_pensionUnit } from '@/queries/__generated__/pensionUnitSelections';
import { GQL_getAmeldingResendData_amelding } from '@/queries/__generated__/getAmeldingResendData';
import Decimal from '@/utils/decimal';
import { paycheckReadyForAmelding } from '@/app/Paycheck';
import formatPaycheckNumber from '@/filters/formatPaycheckNumber';
import { municipalityFragments } from '@/queries/Municipality';
import gql from 'graphql-tag';
import { GQL_sendAltinn3AmeldingVariables } from '@/queries/__generated__/sendAltinn3Amelding';

const AMELDING_NEW_DATA = gql`
  query ameldingNewData($calendarMonth: String!) {
    currentUnit {
      id
      subUnits {
        id
        name
        workRelations {
          id
          startDate
          endDate
          endReason
          samePositionSince
          shiftType
          employmentType
          employmentPercentage
          employmentPercentageUpdated
          hoursEveryWeekWithFullEmployment
          lastSalaryChange
          durationType
          leaveAndLayoffs(calendarMonth: $calendarMonth) {
            id
            description
            startDate
            endDate
          }
          employee {
            id
            firstName
            lastName
          }
          occupation {
            id
            name
          }
          subUnit {
            id
          }
          sentToAltinn(calendarMonth: $calendarMonth)
          endDateSentToAltinn
          paychecksForAmelding(calendarMonth: $calendarMonth) {
            id
            number
            journalDate
            dueDate
            startDate
            endDate
            employeeBban
            lockedAt
            paidDate
            samePositionSince
            shiftType
            employmentType
            employmentPercentage
            employmentPercentageUpdated
            hoursEveryWeekWithFullEmployment
            lastSalaryChange
            isSentToAltinn
            workRelationEndDate
            workRelationDurationType
            workRelationEndReason
            shouldSendToAltinn
            sentToAltinnInReport {
              id
              ameldingReference
            }
            workRelation {
              id
            }
            companyMunicipality {
              ...municipalityFragments
            }
            occupation {
              id
              name
            }
          }
        }
      }
    }
  }
  ${municipalityFragments}
`;

const SEND_ALTINN3_AMELDING = gql`
  mutation sendAltinn3Amelding(
    $unitId: ID!,
    $ameldingData: AmeldingDataInput!,
  ) {
    sendAltinn3Amelding(
      input: {
        unitId: $unitId,
        data: $ameldingData,
      }
    ) {
      amelding { id }
    }
  }
`;


export type WithSelectedFlag<T> = T & {
  $_selected: boolean;
};

export type WithOverwrite<T> = T & {
  overwrite?: PickedWorkRelation;
};

export type AdditionalField = {
  pensionAmount: Decimal;
  reimbursementAmount: Decimal;
  subUnitId: string;
  employerTaxZoneId: string;
}

@Component({
  components: {
    AmeldingFormSubUnit,
  },
})
export default class AmeldingForm extends Vue {
  @Prop({ type: String, required: true }) private calendarMonth!: string;
  @Prop({ type: Object}) private ameldingToReplace?: GQL_getAmeldingResendData_amelding;

  @SmartQuery<AmeldingForm, GQL_ameldingNewData, GQL_ameldingNewDataVariables>({
    query: AMELDING_NEW_DATA,
    fetchPolicy: 'no-cache',
    variables() {
      return {
        calendarMonth: this.calendarMonth,
      };
    },
    update(data) {
      return {
        ...data.currentUnit,
        subUnits: data.currentUnit.subUnits.map(unit => {
          return {
            ...unit,
            workRelations: unit.workRelations
              .filter(wr =>
                filterWorkRelationsForNewAmelding(wr, this.calendarMonth) ||
                this.ameldingToReplace?.ameldingWorkRelations.some(awr => awr.workRelation.id === wr.id),
              )
              .map(wr => {
                const awr =
                  this.ameldingToReplace?.ameldingWorkRelations.find(awr => awr.workRelation.id === wr.id);

                const formwr: WithSelectedFlag<GQL_ameldingNewData_currentUnit_subUnits_workRelations> & WithOverwrite<GQL_ameldingNewData_currentUnit_subUnits_workRelations> =  {
                  ...wr,
                  $_selected: !!awr?.workRelation.id,
                  paychecksForAmelding: wr.paychecksForAmelding.map(p => {
                    const fromReplacement = this.ameldingToReplace?.paychecks.some(pfa => pfa.id === p.id) || false;
                    return {
                      ...p,
                      $_selected: fromReplacement,
                      isSentToAltinn: !fromReplacement && p.isSentToAltinn,
                    };
                  }),
                };
                if (awr) {
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  (formwr as any).overwrite = {...awr};
                }
                return formwr;
              }),
          };
        }),
      };
    },
    result() {
      if (this.ameldingToReplace) {
        this.ameldingToReplace.ameldingPensionAmounts.forEach(pa => {
          this.additionalFields.push({
            subUnitId: pa.subUnit.id,
            employerTaxZoneId: pa.employerTaxZone.id,
            reimbursementAmount: new Decimal(0),
            pensionAmount: pa.amount,
          });
        });

        this.ameldingToReplace.ameldingReimbursements.forEach(ar => {
          const existingAF = this.additionalFields.find(af => (
            af.subUnitId == ar.subUnit.id &&
            af.employerTaxZoneId == ar.employerTaxZone.id
          ));
          if (existingAF) {
            existingAF.reimbursementAmount = ar.amount;
          } else {
            this.additionalFields.push({
              subUnitId: ar.subUnit.id,
              employerTaxZoneId: ar.employerTaxZone.id,
              reimbursementAmount: ar.amount,
              pensionAmount: new Decimal(0),
            });
          }
        });
      }
    },
  }) private ameldingNewData!: WithSelectedFlag<GQL_ameldingNewData_currentUnit>;

  @SmartQuery<AmeldingForm, GQL_pensionUnitSelections>({
    query: ALL_PENSION_UNIT_SELECTIONS,
    update: data => data.currentUnit.pensionUnitSelections,
  }) pensionUnitSelections!: GQL_pensionUnitSelections_currentUnit_pensionUnitSelections[];


  @Ref() private subUnitForms?: AmeldingFormSubUnit[];

  private SEND_ALTINN3_AMELDING = SEND_ALTINN3_AMELDING;

  private showPensionUnitsToBeSentWarning = true;

  public additionalFields: AdditionalField[] = [];

  private newAmelding(): GQL_sendAltinn3AmeldingVariables {
    return {
      unitId: this.ameldingNewData.id,
      ameldingData: {
        calendarMonth: this.calendarMonth,
        ameldingToReplaceId: this.ameldingToReplace?.id,
        paycheckIds: this.selectedPaychecks.map(p => p.id),
        ameldingWorkRelations: this.selectedWorkRelations.map((wr: WithOverwrite<GQL_ameldingNewData_currentUnit_subUnits_workRelations>) => ({
          workRelationId: wr.id,
          subUnitId: wr.subUnit.id,
          startDate: wr.startDate,
          endDate: wr.overwrite ? wr.overwrite.endDate : wr.endDate,
          occupationId: wr.overwrite ? (wr.overwrite.occupation?.id || '') : (wr.occupation?.id || ''),
          samePositionSince: wr.overwrite ? wr.overwrite.samePositionSince : wr.samePositionSince,
          shiftType: wr.overwrite ? wr.overwrite.shiftType : wr.shiftType,
          employeeId: wr.employee.id,
          employmentType: wr.overwrite ? wr.overwrite.employmentType : wr.employmentType,
          employmentPercentage: wr.overwrite ? wr.overwrite.employmentPercentage : wr.employmentPercentage,
          employmentPercentageUpdated: wr.overwrite ? wr.overwrite.employmentPercentageUpdated : wr.employmentPercentageUpdated,
          hoursEveryWeekWithFullEmployment: wr.overwrite ? wr.overwrite.hoursEveryWeekWithFullEmployment : wr.hoursEveryWeekWithFullEmployment,
          lastSalaryChange: wr.overwrite ? wr.overwrite.lastSalaryChange : wr.lastSalaryChange,
          durationType: wr.overwrite ? wr.overwrite.durationType : wr.durationType,
          endReason: wr.overwrite ? wr.overwrite.endReason : wr.endReason,
        })),

        pensionAmounts: this.additionalFields
          .filter(f => !f.pensionAmount.isZero())
          .map(f => ({
            amount: f.pensionAmount,
            subUnitId: f.subUnitId,
            employerTaxZoneId: f.employerTaxZoneId,
          })),

        reimbursements: this.additionalFields
          .filter(f => !f.reimbursementAmount.isZero())
          .map(f => ({
            amount: f.reimbursementAmount,
            subUnitId: f.subUnitId,
            employerTaxZoneId: f.employerTaxZoneId,
          })),
      },
    };
  }

  private get selectedWorkRelations(): WithOverwrite<GQL_ameldingNewData_currentUnit_subUnits_workRelations[]> {
    return this.ameldingNewData.subUnits.flatMap(subUnit =>
      (subUnit.workRelations as WithSelectedFlag<GQL_ameldingNewData_currentUnit_subUnits_workRelations>[])
        .filter(wr => wr.$_selected),
    );
  }

  private get selectedPaychecks(): GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding[] {
    return this.selectedWorkRelations.flatMap(wr =>
      (wr.paychecksForAmelding as WithSelectedFlag<GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding>[])
        .filter(p => p.$_selected));
  }

  private get hasUnresolvedConflictingData(): boolean {
    if (!this.subUnitForms) return false;

    const results: boolean[] = [];
    this.subUnitForms.map(sub => {
      sub.workRelationForms && sub.workRelationForms.forEach(wr => {
        results.push(wr.dataConflictResolved);
      });
    });
    return results.some(r => !r);
  }

  private get pensionUnitsToBeSent(): GQL_pensionUnitSelections_currentUnit_pensionUnitSelections_pensionUnit[] {
    return this.pensionUnitSelections
      .filter(selection =>
        this.$dayjs.strict(selection.validFrom).isSame(this.calendarMonth, 'month') ||
        (selection.validTo && this.$dayjs.strict(selection.validTo).isSame(this.calendarMonth, 'month')) ||
        this.$dayjs.strict(`${this.calendarMonth}-01`).isBetween(selection.validFrom, selection.validTo || '3000-01-01'),
      )
      .map(selection => selection.pensionUnit);
  }

  @Emit()
  private ameldingSent(): void {}

  @Watch('calendarMonth')
  private resetShowPensionUnitsToBeSentWarning(): void {
    this.showPensionUnitsToBeSentWarning = true;
  }

  private addAdditionalField(params: { subUnitId: string; employerTaxZoneId: string}) {
    this.additionalFields.push({
      subUnitId: params.subUnitId,
      employerTaxZoneId: params.employerTaxZoneId,
      pensionAmount: new Decimal(0),
      reimbursementAmount: new Decimal(0),
    });
  }

  private removeAdditionalField(params: { subUnitId: string; employerTaxZoneId: string}) {
    this.additionalFields.splice(
      this.additionalFields.findIndex(f => (
        f.employerTaxZoneId == params.employerTaxZoneId &&
        f.subUnitId == params.subUnitId
      )),
      1,
    );
  }

  private selectAllCheckbox = false;
  private showUnlockedPaychecksWarningDialog = false;
  private formatPaycheckNumber = formatPaycheckNumber;

  private get unlockedPaychecks(): GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding[] {
    return this.ameldingNewData.subUnits.flatMap(subunit => {
      return subunit.workRelations.flatMap(wr => {
        return wr.paychecksForAmelding.filter(paycheck => !paycheck.lockedAt);
      });
    });
  }

  private selectAll() {
    this.ameldingNewData.subUnits.forEach(subunit => {
      (subunit.workRelations as WithSelectedFlag<GQL_ameldingNewData_currentUnit_subUnits_workRelations>[])
        .forEach(wr => {
          wr.$_selected = this.selectAllCheckbox;

          (wr.paychecksForAmelding as WithSelectedFlag<GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding>[])
            .forEach(paycheck => {
              if (paycheckReadyForAmelding(paycheck)) {
                paycheck.$_selected = this.selectAllCheckbox;
              }
            });
        });
    });

    if (this.selectAllCheckbox && this.unlockedPaychecks.length) {
      this.showUnlockedPaychecksWarningDialog = true;
    }
  }
}
